module.exports = __webpack_public_path__ + "static/media/Togo.48d2c2f8.png";